import React from "react";

function Silent() {
    return (
        <div id="container-strict">
        <div id="silent"> 
            <div className="center" style={{ marginBottom: "0.5em" }}>竹</div>       
            <div className="center"> <div>自 </div><div>合</div><div>天</div></div>   
            <div className="center"> <div>平</div><div>安</div><div>神</div></div>
            <div className="center" style={{ marginTop: "0.5em" }}>木</div>
       </div>
       </div>
    );
    
}
  
 export default Silent;
